import React from "react";

import { IconButton } from "@toddle-edu/ds-web";
import { ChevronLeftOutlined } from "@toddle-edu/ds-icons";

import { ToddleIcon } from "SvgComponents";
import classes from "./Header.scss";

function Header({ headerText, closeModal }) {
  return (
    <div className={classes.container}>
      <IconButton
        dsVersion="2.0"
        type="plain"
        variant="neutral"
        icon={<ChevronLeftOutlined />}
        onClick={closeModal}
        size="medium"
        testId="appComponents-leIntoUnitImport-header-back"
      />
      <div className={classes.logoContainer}>
        <ToddleIcon width={32} height={32} />
        <h6>{headerText}</h6>
      </div>
    </div>
  );
}

export default Header;
